module.exports = __webpack_public_path__ + "static/logo-cous.0be16070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-cous.png
// module id = 231
// module chunks = 35783957827783 213720915766396